import { render, staticRenderFns } from "./NavBarInicio.vue?vue&type=template&id=6ff9b226&scoped=true"
import script from "./NavBarInicio.vue?vue&type=script&lang=js"
export * from "./NavBarInicio.vue?vue&type=script&lang=js"
import style0 from "./style.css?vue&type=style&index=0&id=6ff9b226&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff9b226",
  null
  
)

export default component.exports